import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { CommunityTheme } from '../theme/communitytheme';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { authConfig } from './auth/auth.config';
import { AbstractSecurityStorage, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { TimeLeftService } from './services/time-left.service';
import { AbsoluteMediaUriService } from './services/absolute-media-uri.service';
import { LocalStorageService } from './services/authentication/local-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { errorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({
      scrollPositionRestoration: 'enabled', // restores or goes to top
      anchorScrolling: 'enabled'           // supports #anchors
    })
    ),
    provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
    provideAnimationsAsync(),
    importProvidersFrom(FormsModule),
    provideHttpClient(withFetch(), withInterceptors([errorInterceptor])),
    DialogService,
    TimeLeftService,
    AbsoluteMediaUriService,
    ConfirmationService,
    providePrimeNG({

      theme: {
        preset: CommunityTheme, // default theme 
        options: {
          darkModeSelector: 'none'
        }
      }
    }),
    provideAuth(authConfig),
    { provide: AbstractSecurityStorage, useClass: LocalStorageService },
    MessageService
  ]
};
